import React from 'react';
import { connect } from 'react-redux';
import { RootState } from 'reducers';
import { RouteComponentProps, Link } from 'react-router-dom';
import { Globals, Constants, Colors, Print, checkPermission } from 'utils';
import {
  Table,
  Pagination,
  Tooltip,
  Input,
  DatePicker,
  Select,
  Modal,
} from 'components';
import { CleanIcon } from 'assets/icons';
import moment from 'moment';
import { ReportService } from 'services';

interface Props extends RootState {}

const INITIAL_STATE = {
  search: '',
  payment_method_id: '',
  date: '',
};

class Payments extends React.Component<Props> {
  timer: any = undefined;

  state = {
    header: [
      'Nro. de ID',
      'Fecha',
      'Motivo de pago',
      'Monto pagado',
      'Método de pago',
      'Nro de referencia',
    ],
    form: INITIAL_STATE,
    data: [],
    page: 1,
    last_page: 1,
    item: null,
    visible: false,
    payment_methods: [],
  };

  componentDidMount() {
    this.load();
    this.loadPaymentMethods();
  }

  load = async (withoutLoading = false) => {
    const res: any = await ReportService.getPayments({
      withoutLoading,
      page: this.state.page,
      ...this.state.form,
      user_id: this.props.user?.id,
      date:
        this.state.form.date &&
        moment(this.state.form.date).format('YYYY-MM-DD'),
    });
    this.setState({
      data: res.payments.rows,
      last_page: res.payments.count,
    });
  };

  loadPaymentMethods = async () => {
    const res: any = await ReportService.getPaymentMethods({
      withoutLoading: true,
    });
    this.setState({
      payment_methods: res.payment_methods || [],
    });
  };

  change = (e: any, callback = () => {}) => {
    this.setState(
      {
        page: 1,
        form: {
          ...this.state.form,
          [e.target.name]: e.target.value,
        },
      },
      callback,
    );
  };

  reset = () => {
    this.setState(
      {
        form: INITIAL_STATE,
        page: 1,
      },
      () => this.load(true),
    );
  };

  render() {
    return (
      <div id="client-reports-payments">
        <div className="row row-filter">
          <div className="col-md-12">
            <div className="row">
              <div className="col-md-3">
                <Input
                  value={this.state.form.search}
                  name="search"
                  label="Buscar"
                  placeholder="Nº Referencia"
                  className="input-table"
                  onSubmit={() => this.load()}
                  onChange={(e: any) => {
                    clearTimeout(this.timer);
                    this.timer = setTimeout(() => {
                      this.load(true);
                    }, 1000);
                    this.change(e);
                  }}
                />
              </div>
              <div className="col-md-3">
                <Select
                  color="white"
                  placeholder="Seleccionar"
                  label="Método de pago"
                  name="payment_method_id"
                  onChange={(e: any) =>
                    this.change(e, async () => {
                      this.load(true);
                    })
                  }
                  value={this.state.form.payment_method_id}
                  options={this.state.payment_methods.map((item: any) => {
                    return {
                      value: item.id,
                      label: item.name,
                    };
                  })}
                />
              </div>
              <div className="col-md-3">
                <DatePicker
                  label="Fecha"
                  placeholder="Fecha"
                  maxDate={moment().toDate()}
                  onChange={(text: string) => {
                    this.change(
                      {
                        target: {
                          value: text,
                          name: 'date',
                        },
                      },
                      () => this.load(true),
                    );
                  }}
                  value={this.state.form.date}
                />
              </div>
              <div className="col-md-1">
                {this.state.form != INITIAL_STATE && (
                  <button
                    className="btn btn-clean"
                    onClick={() => this.reset()}
                  >
                    <img src={CleanIcon} />
                  </button>
                )}
              </div>
            </div>
          </div>
        </div>

        <Table
          title=""
          data={this.state.data.length}
          header={this.state.header}
        >
          {this.state.data.map((i: any, index: number) => {
            return (
              <tr key={index}>
                <td className="blue">{i.number}</td>
                <td>{moment(i.created_at).format('DD/MM/YYYY')}</td>
                <td className="bold">{i.reason}</td>
                <td>{Globals.formatMiles(i.total)}</td>
                <td>{i.payment_method?.name}</td>
                <td>{i.reference}</td>
              </tr>
            );
          })}
        </Table>

        <Pagination
          pages={this.state.last_page}
          active={this.state.page}
          onChange={async (page: number) => {
            await this.setState({
              page: page,
            });
            this.load();
          }}
        />
      </div>
    );
  }
}

export default connect((state: RootState) => {
  return {
    user: state.user,
  };
})(Payments);
